module.exports = __webpack_public_path__ + "img/b3.47cae23a.png";